import React from 'react';
import { CarouselWidget, GridWidget, ListWidget } from '@reviewshake-app/shake-ui';
import SummaryContainer from './SummaryContainer';
import useReviewConnection from '../../hooks/useReviewConnection';
import { ReviewWidget } from '../../types';
import FloatingWidgetContainer from './FloatingWidgetContainer';

type Props = {
  data: ReviewWidget;
  token: string;
};

const Widget = ({ data, token }: Props) => {
  const { reviews, onLoadMore, loading } = useReviewConnection({
    token,
  });

  switch (data.widgetType) {
    case 'CAROUSEL':
      return (
        <SummaryContainer data={data}>
          <CarouselWidget
            data={data as any}
            reviews={reviews}
            onLoadMore={onLoadMore}
            loading={loading}
          />
        </SummaryContainer>
      );
    case 'GRID':
      return (
        <SummaryContainer data={data}>
          <GridWidget
            data={data as any}
            reviews={reviews}
            onLoadMore={onLoadMore}
            loading={loading}
          />
        </SummaryContainer>
      );
    case 'LIST':
      return (
        <SummaryContainer data={data}>
          <ListWidget
            data={data as any}
            reviews={reviews}
            onLoadMore={onLoadMore}
            loading={loading}
          />
        </SummaryContainer>
      );
    case 'FLOATING':
      return (
        <FloatingWidgetContainer
          data={data}
          reviews={reviews}
          onLoadMore={onLoadMore}
          loading={loading}
        />
      );

    default:
      return null;
  }
};

export default Widget;
